export const MOBILE_SCALE_FACTOR = 1.2
export const TABLET_SCALE_FACTOR = 1.5
export const DESKTOP_SCALE_FACTOR = 2
export const TOP_OFFSET = 64
export const AXIS_SEAT_OFFSET = 4 // The axis letter is smaller than the seat so we have to move it further
